import { useEndpointRequestCount } from '../../hooks/useEndpoints';
import { formatCount } from '../../utils/formatUtils';

interface EndpointRequestCountProps {
  endpointId: string;
}

export default function EndpointRequestCount({ endpointId }: EndpointRequestCountProps) {
  const { data: requestCount, isLoading } = useEndpointRequestCount(endpointId);

  if (isLoading) {
    return (
      <span className="inline-block w-12 h-3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
    );
  }

  if (requestCount === undefined) {
    return <span className="text-gray-400">-</span>;
  }

  return <span>{formatCount(requestCount)}</span>;
}
